<template>
  <div class="minwidth w100 mw100" style="background-color: #151419;">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img style="width: 100%;height: auto;-webkit-filter: contrast(90%);filter: contrast(90%);"
        :src="require('../../public/img/news/news_banner.png')" />
    </div>

    <div class="pcScreen" style="width: 55%;margin: 0 auto;padding-top: 3%;">
      <div v-for="(item,index) in msglist" @click="gotoNewsDetail(index)">
        <div v-if="index%2 == 0" style="display: flex;padding: 2% 0;background-color: #25242A;width: 100%;margin: 0 auto;justify-content: space-around;border-radius: 0.5em;margin-bottom: 3%;cursor: pointer;color: #C5B497;height: 10em;">
          <div style="width: 50%;">
            <div style="font-size: max(13px,1.3vw);margin-top: 2%;height: 30%;">
              {{ item.title }}
            </div>
            <div
              style="font-size: max(8px,0.8vw);overflow: hidden;text-overflow: ellipsis;text-align: justify;margin-top: 5%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;line-clamp: 4;">
              {{ item.content }}
            </div>
          </div>
          <div style="width: 40%;text-align: right;display: flex;justify-content: center;align-items: center;">
            <img style="width: 95%;height: 90%;object-fit: contain;" :src="item.url" alt="">
          </div>
        </div>
        <div v-else style="display: flex;padding: 2% 0;background-color: #25242A;width: 100%;margin: 0 auto;justify-content: space-around;border-radius: 0.5em;margin-bottom: 3%;cursor: pointer;color: #C5B497;height: 10em;">
          <div style="width: 40%;display: flex;justify-content: center;align-items: center;">
            <img style="width: 95%;height: 90%;object-fit: contain;" :src="item.url" alt="">
          </div>
          <div style="width: 50%;">
            <div style="font-size: max(13px,1.3vw);margin-top: 2%;height: 30%;">
              {{ item.title }}
            </div>
            <div
              style="font-size: max(8px,0.8vw);overflow: hidden;text-overflow: ellipsis;text-align: justify;margin-top: 5%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;line-clamp: 4;">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobileScreen" style="width: 90%;margin: 0 auto;padding-top: 3%;">
      <div v-for="(item,index) in msglist" @click="gotoNewsDetail(index)">
        <div v-if="index%2 == 0" style="display: flex;padding: 2% 0;background-color: #25242A;width: 100%;margin: 0 auto;justify-content: space-around;border-radius: 0.5em;margin-bottom: 3%;cursor: pointer;color: #C5B497;height: 7em;">
          <div style="width: 50%;">
            <div style="font-size: 3vw;margin-top: 2%;height: 35%;">
              {{ item.title }}
            </div>
            <div
              style="font-size: 1.9vw;overflow: hidden;text-overflow: ellipsis;text-align: justify;margin-top: 5%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;line-clamp: 4;">
              {{ item.content }}
            </div>
          </div>
          <div style="width: 40%;text-align: right;display: flex;justify-content: center;align-items: center;">
            <img style="width: 95%;height: 90%;object-fit: contain;" :src="item.url" alt="">
          </div>
        </div>
        <div v-else style="display: flex;padding: 2% 0;background-color: #25242A;width: 100%;margin: 0 auto;justify-content: space-around;border-radius: 0.5em;margin-bottom: 3%;cursor: pointer;color: #C5B497;height: 7em;">
          <div style="width: 40%;display: flex;justify-content: center;align-items: center;">
            <img style="width: 95%;height: 90%;object-fit: contain;" :src="item.url" alt="">
          </div>
          <div style="width: 50%;">
            <div style="font-size: 3vw;margin-top: 2%;height: 35%;">
              {{ item.title }}
            </div>
            <div
              style="font-size: 1.9vw;overflow: hidden;text-overflow: ellipsis;text-align: justify;margin-top: 5%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;line-clamp: 4;">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        msglist: [
          {
            url: require('../../public/img/news/image1.png'),
            title: '2024年软件业十大趋势前瞻',
            content: '2024年软件开发10大趋势：无代码/低代码兴起、AI/ML进化、AR/VR融合、IoT扩展、网络安全升级、云原生/微服务、边缘计算崛起、即时应用增多、开源软件繁荣、绿色编码受重视。无代码和低代码平台的普及让非技术人员也能参与软件开发。这些平台通过直观的界面和可视化工具，简化了应用程序开发流程。2024年，随着这些平台的不断优化，预计它们将推动市场上快速增长的应用需求，尤其是中小型企业和初创公司，它们将能够以更小的成本和更短的时间推出创新产品。'
          },
          {
            url: require('../../public/img/news/image4.png'),
            title: '未来属于AI？马斯克大胆预测：2027年AI智力将反超人类',
            content: '埃隆·马斯克最近在社交媒体上发表了关于人工智能(AI)未来的大胆预言。马斯克指出，AI正以惊人的速度发展，而人类对这一变革的认知却显得相对迟缓。他大胆预言，在2025年底之前，AI的智力水平将超越任何单独的人类个体。到了2027年至2028年间，AI的整体智力或将凌驾于全人类之上。马斯克还强调，随着时间的推移，AI超越所有人类智力的趋势将愈发明显。他预计，到2030年，这一概率将逼近100%，标志着AI智力全面超越人类的新时代的到来。'
          },
          {
            url: require('../../public/img/news/image5.png'),
            title: '“云+AI”赋能千行百业数智化转型升级',
            content: '在数字化时代，市场对云的需求进入到深度用云的阶段。尤其是伴随着人工智能的飞速发展，上云场景越来越复杂，需求越来越多样化，大量应用场景需要各专业协同去落地，共建生态是各行各业的诉求。12月18日，“全栈可信 云中生智”曙光云战略发布会召开。曙光云从首创“城市云”进化到实现“全栈智能云”，打造“云算、云数、云安、云智”四位一体能力体系，深度赋能千行百业数智化转型升级。曙光云副总裁孙会首表示，智能化是一个多维度的概念，站在不同的角度理解会有所不同。从供给侧来看，智能化意味着提供先进的技术解决方案，如选用合适的算力、构建大模型算法等。'
          },
          {
            url: require('../../public/img/news/image6.png'),
            title: 'Anthropic：2025年AI进化更剧烈，运算成本激增',
            content: '随着人工智能的跨越式发展，2024年，人形机器人逐渐从科幻走向现实，成为科技界的新热点。科技巨头纷纷布局、初创公司相继涌现、供应链不断完善、技术层层迭代……人形机器人作为人工智能领域最具代表性的实体，在大模型的催化下，正加速从实验室走向生产线，实现产业化落地。与2023年相比，今年的人形机器人市场，已经不再相信酷炫的宣传片和科技幻想故事，人形机器人的成本能降到多低？他们能用在哪里？成为市场最关切的话题。'
          },
          {
            url: require('../../public/img/news/image7.png'),
            title: '不再“困”于宣传片里，人形机器人从科幻走向现实',
            content: '随着人工智能的跨越式发展，2024年，人形机器人逐渐从科幻走向现实，成为科技界的新热点。科技巨头纷纷布局、初创公司相继涌现、供应链不断完善、技术层层迭代……人形机器人作为人工智能领域最具代表性的实体，在大模型的催化下，正加速从实验室走向生产线，实现产业化落地。与2023年相比，今年的人形机器人市场，已经不再相信酷炫的宣传片和科技幻想故事，人形机器人的成本能降到多低？他们能用在哪里？成为市场最关切的话题。'
          }
        ],

        num: 0,
      };
    },

    mounted() {
      this.num = this.$route.query.num;
    },

    methods: {
      gotoNewsDetail(num) {
        this.$router.push({ path: '/newsDetail', query: { num: num } })
      }
    },


  };
</script>

<style scoped>
  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .positionrel {
    position: relative;
    overflow: hidden;
  }
  
  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>